module.exports = __webpack_public_path__ + "img/location.5af6d580.png";